import React from "react"
import MenuCardAltered from "./subcomponents/MenuCardAltered"
import { Link } from "react-router-dom"

export default function Cart() {
    const [checkoutDetails, changeCheckoutDetails] = React.useState(false)
    const [cartPrice, changeCartPrice] = React.useState(0)
    const [cartItems, changeCartItems] = React.useState(JSON.parse(localStorage.getItem("cart")) ? JSON.parse(localStorage.getItem("cart")) : [])
    let cartPriceTotal = 0;
    
    let cartElements = cartItems.map((data, index) => {
        cartPriceTotal = cartPriceTotal + parseFloat(data.price.replace("$", "")) * data.amount
        return (
            <MenuCardAltered 
                image={data.image}
                header={data.header}
                price={data.price}
                description={data.description}
                amount={data.amount}
                key={index}
                delay={index % 3 === 0 && window.innerWidth >= 1575 ? "100" : (index + 1) % 3 === 0  && window.innerWidth >= 1575 ? "500" : window.innerWidth >= 1575  ? "300" : index % 2 === 0 && window.innerWidth >= 950 ? "100" : window.innerWidth >= 950 ? "300" : "0"}
            />
        )
    })

    React.useEffect(() => {
        changeCartPrice(cartPriceTotal)
    }, [cartPriceTotal])
    
    window.addEventListener('cart', () => {
        changeCartItems(JSON.parse(localStorage.getItem("cart")))
    })

    function openCheckout() {
        changeCheckoutDetails(!checkoutDetails)
    }
    return (
        <main>
            <section className="cart">
                <div className="cartDecorationBall"></div>
                <h1 data-aos="fade-up" data-aos-once="true" data-aos-delay="100">My Cart</h1>
                <div className={cartItems.length === 0 ? "nothingCart" : "nothingCart nothingCartGone"}>
                    <i className="fa-solid fa-cart-shopping" data-aos="fade-up" data-aos-once="true" data-aos-delay="300"></i>
                    <h2 data-aos="fade-up" data-aos-once="true" data-aos-delay="400">Cart is Empty</h2>
                    <p data-aos="fade-up" data-aos-once="true" data-aos-delay="500">Looks like you have no items in your cart. Click the button to keep on shopping!</p>
                    <div data-aos="fade-up" data-aos-once="true" data-aos-delay="600">
                        <Link to="/menu">Shop Now</Link>
                    </div>
                </div>
                <section className="fullMenu">
                    <div className="menuElements">
                        {cartElements}
                    </div>
                </section>
                <div className={checkoutDetails ? "cartCheckoutContainer cartCheckoutContainerActive" : "cartCheckoutContainer"}>
                    <div className="cartCheckoutOpenClose">
                        <i class={checkoutDetails ? "fa-solid fa-angle-down" : "fa-solid fa-angle-up"} onClick={openCheckout}></i>
                    </div>
                    <div className="cartCheckoutCalculations">
                        <div className="cartCheckoutCalculation">
                            <p className="cartCalculationTextOne">Cost:</p>
                            <p className="cartCalculationTextTwo">{cartPrice}$</p>
                        </div>
                        <div className="cartCheckoutCalculation">
                            <p className="cartCalculationTextOne">Tax:</p>
                            <p className="cartCalculationTextTwo">{Math.round(((cartPrice * 0.12) + Number.EPSILON) * 100) / 100}$</p>
                        </div>
                        <div className="cartCheckoutDecorativeLine"></div>
                        <p className="cartCheckoutTotal">{cartPrice + Math.round(((cartPrice * 0.12) + Number.EPSILON) * 100) / 100}$</p>
                    </div>
                    <div className="cartCheckoutButton">Proceed To Checkout</div>
                </div>
            </section>
        </main>
    )
}